export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="text-center md:text-left">
              <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-500 mb-2">
                Chad Sakers
              </h3>
              <p className="text-slate-400">First-Time Home Buying Specialist</p>
            </div>

            <div className="text-center md:text-right space-y-2">
              <div>
                <a href="tel:404-547-4731" className="text-blue-400 hover:text-blue-300 transition-colors font-semibold">
                  404-547-4731
                </a>
              </div>
              <div>
                <a href="mailto:chad@ntd1stclassrealty.com" className="text-blue-400 hover:text-blue-300 transition-colors font-semibold">
                  chad@ntd1stclassrealty.com
                </a>
              </div>
              <div className="text-slate-500 text-sm">
                Zoom: 899 4399 4478
              </div>
            </div>
          </div>

          <div className="border-t border-slate-800 mt-8 pt-8 text-center">
            <p className="text-slate-500 text-sm">
              <a href="/policy" className="hover:text-slate-300 transition-colors">Privacy Policy / Terms & Conditions</a>
            </p>
            <p className="text-slate-600 text-sm mt-2">
              © 2025 Chad Sakers. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
